module.exports = __webpack_public_path__ + "img/logo_new.09690956.png";